"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bundleRoutingMiddleware = bundleRoutingMiddleware;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Bundle = (Component, routeProps = {}) => props => /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, routeProps));
function bundleRoutingMiddleware(action, nextRoute, prevRoute) {
  const {
    match
  } = nextRoute;
  if (match && !match.render && typeof match.load === 'function') {
    match.load(asyncModule => {
      match.render = Bundle(asyncModule.default ? asyncModule.default : asyncModule, match.props);
      action.ok();
    });
  } else {
    action.ok();
  }
}
//# sourceMappingURL=bundle.js.map